export default function PastorMessage() {
  return (
    <section className="w-full py-20 bg-[#F5E9D8]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 px-4">
        {/* Pastor Image */}
        <div
          data-aos="fade-right"
          className="w-full h-[500px] md:h-[650px] bg-gray-300 rounded-xl shadow-md bg-cover bg-center"
          style={{ backgroundImage: "url('/Images/pastor.jpg')" }}
        />

        {/* Text */}
        <div className="flex flex-col justify-center" data-aos="fade-left">
          <h2 className="text-3xl font-bold text-[#1A1F2B]">
            Pastor’s Message
          </h2>

          <p className="text-gray-700 mt-4 leading-relaxed">
            Greetings in the name of Jesus Christ.
            <br />
            <br />
            At Moriah Church, we welcome you with open hearts. Our desire is to
            help you grow in faith, hope, and love as we walk this journey
            together in Christ.
          </p>

          <h3 className="text-2xl font-semibold text-[#1A1F2B] mt-8">
            Our Vision
          </h3>

          <p className="text-gray-700 mt-3 leading-relaxed">
            Our vision at Moriah Church, Prarthana Bhawan is to be a
            Christ-centered haven where hearts are spiritually nourished, faith
            is strengthened, and lives are transformed by the power of God’s
            presence.
          </p>

          <p className="text-gray-700 mt-3 leading-relaxed">
            We seek to foster deep and meaningful relationships, encourage
            spiritual growth through prayer, worship, and God’s Word, and
            inspire every individual to live a life of service, compassion, and
            integrity—reflecting Christ’s love and hope in word and action.
          </p>
        </div>
      </div>
    </section>
  );
}
